import React, { useContext } from 'react';

import { footerClassName } from '../style.css';
import { PreloaderContext } from './PreloaderContext';
import { PreloaderSpinner } from './PreloaderSpinner';

export type PreloaderFooterProps = {
  children?: React.ReactNode;
}

export const PreloaderFooter: React.FC<PreloaderFooterProps> = ({ children }) => {
  const { showFooter, show } = useContext(PreloaderContext);

  if (!showFooter) return null;

  return (
    <div className={footerClassName[show ? 'visible' : 'hidden']} data-e2e="preloader-footer">
      {children ?? <PreloaderSpinner />}
    </div>
  );
};
